var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncomingMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_arrow_down",
    transform: "translate(-4301 -3366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    transform: "translate(4301 3366)",
    fill: "#e9e9e9",
    stroke: "#97989a",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 28,
    rx: 28,
    ry: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 28,
    rx: 25.5,
    ry: 25.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "arrow_downward_alt_24dp_E3E3E3_FILL1_wght500_GRAD0_opsz24",
    d: "M238.389-752.5l-6.039-6.039,1.552-1.552,3.377,3.377V-765.5H239.5v8.787l3.377-3.377,1.552,1.552Z",
    transform: "translate(4090.61 4140.885)",
    fill: "#97989a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mail_24dp_E3E3E3_FILL1_wght500_GRAD0_opsz24",
    d: "M74.5-788.564a2.5,2.5,0,0,1-1.861-.793,2.657,2.657,0,0,1-.769-1.92v-14.14a2.657,2.657,0,0,1,.769-1.92,2.5,2.5,0,0,1,1.861-.793H92.835a2.5,2.5,0,0,1,1.861.793,2.657,2.657,0,0,1,.769,1.92v14.14a2.657,2.657,0,0,1-.769,1.92,2.5,2.5,0,0,1-1.861.793Zm9.167-8.284,9.167-5.963v-2.606l-9.167,5.963L74.5-805.417v2.606Z",
    transform: "translate(4245.332 4199.419)",
    fill: "#97989a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingMessage);
export default __webpack_public_path__ + "static/media/IncomingMessage.93d6d0441a2ffaca766abc8216298e5d.svg";
export { ForwardRef as ReactComponent };